import {LanguageSwitcherConfiguration} from "../../app-bootstrap/config-interfaces/b2c-startup.configurations";
import {WheelDialogCirclesBgImgBox} from "../../components/wheel-of-jackpotbet-dialog/boxes/wheel-bg-img/wheel-dialog-circles-bg-img.box";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {IThemeCustomizer} from "./theme.service.interface";

export class StandardThemeCustomizer implements IThemeCustomizer {
    constructor(protected readonly services: IServiceFactoryExtended) { }

    getHomePageTopBannerHeight(): string {
        if (this.services.homepage.useAdminBanner) {
            if (this.services.mediaQuery.sAndBelow) {
                return "22.5rem";
            } else if (this.services.mediaQuery.mAndBelow) {
                return "40rem";
            }
            return "27rem";
        } else {
            if (this.services.mediaQuery.sAndBelow) {
                return "23rem";
            } else if (this.services.mediaQuery.mAndBelow) {
                return "30rem";
            }
            return "37rem";
        }
    }

    getFreeToPlayAnimation() {
        return {
            jsonUrl: this.services.theme.currentTheme.assets.images.f2p.freeToPlay_json.toString(),
            size: {
                width: 445,
                height: 364
            },
            animationName: undefined
        };
    }

    getLanguageSwitcherConfigForTestEnvironments(): LanguageSwitcherConfiguration {
        return {
            "languages": [
                {
                    "title": "Deutsch",
                    "url": "https://de.888casino.com/"
                },
                {
                    "title": "Español",
                    "url": "https://es.888casino.com/"
                },
                {
                    "title": "Français",
                    "url": "https://fr.888casino.com/"
                },
                {
                    "title": "日本語",
                    "url": "https://jp.888casino.com/"
                },
                {
                    "title": "Português",
                    "url": "https://br.888casino.com/"
                },
            ],
            "countries": [
                {
                    "title": "Canada",
                    "url": "https://ca.888casino.com/"
                },
                {
                    "title": "España",
                    "url": "https://www.888casino.es"
                },
                {
                    "title": "Danmark",
                    "url": "https://www.888casino.dk"
                },
                {
                    "title": "România",
                    "url": "https://www.888casino.ro"
                },
                {
                    "title": "Italia",
                    "url": "https://www.888casino.it"
                },
                {
                    "title": "Sverige",
                    "url": "https://www.888casino.se"
                },
                {
                    "title": "United States",
                    "url": "https://us.888casino.com"
                },
                {
                    "title": "Portugal",
                    "url": "https://casino.888.pt",
                    "sendFunnelParameters": true
                },
                {
                    "title": "Deutschland",
                    "url": "https://www.888slots.de"
                }
            ],
            "languageSettings": {
                "title": "Choose your language:",
                "current": "English"
            },
            "countrySettings": {
                "title": "Or choose your country:",
                "current": ""
            }
        }
    };

    getWheelOfJackpotbetBackground(): JSX.Element {
        return (<>
            <WheelDialogCirclesBgImgBox innerOrOuter="inner" src={this.services.theme.currentTheme.assets.images.jackpot_bet.jackpot_bet_circle_svg.toString()} />
            <WheelDialogCirclesBgImgBox innerOrOuter="outer" src={this.services.theme.currentTheme.assets.images.jackpot_bet.jackpot_bet_circle_svg.toString()} />
        </>)
    }

    useSquareIconsInJackpotToast(): boolean {
        return false;
    }
}
